/**
 * Кто заводит встречи — только владелец (заказ 2026-10-12). Здесь решается лишь, показывать ли
 * кнопку: право проверяет сервер (`MeetingService.isCreator`: id из настройки или этот логин вместе
 * с ролью BOSS), и чужой запрос он отклонит.
 *
 * <p>Отдельно от `joinMeeting`: список чатов спрашивает это при каждой отрисовке, а вход во
 * встречу живёт в лениво подгружаемом чанке.
 */
const MEETING_CREATOR_LOGIN = 'neovaryag';

export function canManageMeetings(login: string | null | undefined): boolean {
  return typeof login === 'string' && login.trim().toLowerCase() === MEETING_CREATOR_LOGIN;
}
